import {alias, createModelSchema, custom, deserialize, serialize, SKIP} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";


export class PlinkoBucketConfig extends Cloneable {

    static schema() {
        return custom((v) => {
            return v && !v.empty() ? serialize(PlinkoBucketConfig, v) : SKIP;
        }, (v) => {
            return deserialize(PlinkoBucketConfig, v);
        });
    }

    constructor() {
        super();
        this._key = null;
        this._points = 0;
        this._premium = false;
        this._multiplier = 1;
        this._physicsConfig = null;
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get points() {
        return this._points;
    }

    set points(value) {
        this._points = value;
    }

    get premium() {
        return Boolean(this._premium);
    }

    set premium(value) {
        this._premium = value;
    }

    get multiplier() {
        return this._multiplier;
    }

    set multiplier(value) {
        this._multiplier = value;
    }

    valid() {
        if (!this.key || this.key.length === 0) {
            return false;
        }

        if (!Number.isInteger(this.points) || this.points < 0) {
            return false;
        }

        if (!Number.isInteger(this.multiplier) || this.multiplier <= 0) {
            return false;
        }

        return true;
    }

    empty() {
        return false;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new PlinkoBucketConfig());
        } else if (target instanceof PlinkoBucketConfig) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(PlinkoBucketConfig, {
    _key: alias("key", Schema.primitive()),
    _points: alias("points", Schema.primitive()),
    _premium: alias("premium", Schema.primitive()),
    _multiplier: alias("multiplier", Schema.primitive())
});